import { useI18n } from '@/i18n/context';

export function SkipLink() {
  const { t } = useI18n();
  return (
    <a
      href="#main"
      className="sr-only z-50 rounded-xl bg-ink px-4 py-2 font-bold text-white focus:not-sr-only focus:fixed focus:start-4 focus:top-4"
    >
      {t('app.skipToContent')}
    </a>
  );
}
